import React from 'react';

export default function SvgContentHubIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" {...props}>
            <g clipPath="url(#clip0_2648_18606)">
                <path
                    d="M7.5 7.50151C7.49974 7.41278 7.52309 7.32557 7.56766 7.24884C7.61223 7.17212 7.67642 7.10863 7.75363 7.06491C7.83085 7.02119 7.91831 6.9988 8.00703 7.00005C8.09576 7.0013 8.18255 7.02613 8.2585 7.07201L10.757 8.57051C10.8314 8.61484 10.893 8.67773 10.9358 8.75302C10.9785 8.82831 11.001 8.91342 11.001 9.00001C11.001 9.0866 10.9785 9.17171 10.9358 9.247C10.893 9.32229 10.8314 9.38518 10.757 9.42951L8.2585 10.928C8.18251 10.9739 8.09567 10.9987 8.0069 11C7.91814 11.0012 7.83064 10.9788 7.75341 10.935C7.67618 10.8912 7.612 10.8276 7.56747 10.7509C7.52293 10.6741 7.49965 10.5868 7.5 10.498V7.50151Z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.5 6.085V2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5H2.5C2.23478 1.5 1.98043 1.60536 1.79289 1.79289C1.60536 1.98043 1.5 2.23478 1.5 2.5V9.5C1.5 9.76522 1.60536 10.0196 1.79289 10.2071C1.98043 10.3946 2.23478 10.5 2.5 10.5H5.5"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 10.5L5.5 8"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.5 5.5C5.05228 5.5 5.5 5.05228 5.5 4.5C5.5 3.94772 5.05228 3.5 4.5 3.5C3.94772 3.5 3.5 3.94772 3.5 4.5C3.5 5.05228 3.94772 5.5 4.5 5.5Z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2648_18606">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
